import React from 'react'
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material'
import Rating from '../../shared/components/FormComponents/RatingComponent'
import { Theme } from '@mui/material/styles'
import { useSelector } from 'react-redux'
import { getFeedback } from '../../store/settings/settings.selectors'
import Env from '../../shared/config/envConfig'
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';

export interface Feedback {
  createdAt: Date
  content: string
  rating: number
  name: string
  id: string
  public: boolean
}
const FeedbackContent: React.FC = () => {
  const theme: Theme = useTheme()
  const downSm = useMediaQuery(theme.breakpoints.down('sm'))

  const feedback = useSelector(getFeedback)
   /* [
      {createdAt: new Date(), content: 'Hallo Welt', rating: 1, name: 'Krissi'},
      {createdAt: new Date(), content: 'Alles war super. Die Pizza zum Mittag war mega lecker und alle waren unfassbar freundlich. Felix ist der Beste.', rating: 5, name: 'Felix',
      {createdAt: new Date(), content: 'Essen war gut und es gab eine sehr schöne Aussicht. ', rating: 4, name: 'Berta'}

    ]*/
  const deleteFeed = (feedId: string) => {
    const basePath = Env.basePath
    const requestHeaders: HeadersInit = new Headers()
    requestHeaders.set('Accept', 'application/json')
    requestHeaders.set('Content-Type', 'application/json')

    const restUrl = `${basePath}/api/feedback/${feedId}`

    fetch(restUrl, {
      method: 'DELETE',
      credentials: 'include',
      headers: requestHeaders,
    })
      .then((res) => res.json())
      .then((response) => {
        console.log(response)
      })
      .catch((err) => console.log(err))
  }

  return (
    <>
      <Box sx={{ display: 'flex', width: '100%', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
        {feedback?.sort((a, b) => {
          if (a.createdAt > b.createdAt) {
            return -1
          }
          if (a.createdAt < b.createdAt) {
            return 1
          }
          return 0
        }).map((element: Feedback, index: number) =>
          <Box key={index} sx={{ width: downSm ? '100%' : '33%', padding: theme.spacing(4), position: 'relative' }}>
            <Typography variant='h3'>{element.public ? 'Anonym' : element.name}</Typography>
            <Typography variant='body1'>{element.content}</Typography>
            <Rating
              emptyIcon={<FavoriteBorderIcon />}
              filledIcon={<FavoriteIcon />}
              disabled={true} value={element.rating} size='small' color={theme.palette.primary.main}
            />
            {/* Einkommentieren, um Feedback zu löschen */}
            {/* <DeleteIcon sx={{ postition: 'absolute', top: '5px', right: '5px' }} onClick={() => deleteFeed(element.id)} /> */}
          </Box>,
        )}
      </Box>
    </>
  )
}
export default FeedbackContent
